const MODULE_NAME = 'fulcrum/container/Approval/ApprovalDialog'

const UPDATE_WORKFLOW_ID = 'fulcrum/container/Approval/ApprovalDialog/UPDATE_WORKFLOW_ID'
const UPDATE_PROJECT_ID = 'fulcrum/container/Approval/ApprovalDialog/UPDATE_PROJECT_ID'
const UPDATE_COMMENT = 'fulcrum/container/Approval/ApprovalDialog/UPDATE_COMMENT'
const UPDATE_ACTIVE = 'fulcrum/container/Approval/ApprovalDialog/UPDATE_ACTIVE'
const UPDATE_TYPE = 'fulcrum/container/Approval/ApprovalDialog/UPDATE_TYPE'
const UPDATE_SKIPABLES = 'fulcrum/container/Approval/ApprovalDialog/UPDATE_SKIPABLES'
const CLEAR = 'fulcrum/container/Approval/ApprovalDialog/CLEAR'
const UPDATE_DIALOG_TYPE = 'fulcrum/container/Approval/ApprovalDialog/UPDATE_DIALOG_TYPE'
const SET_DIALOG_ACTIVE = 'fulcrum/container/Approval/ApprovalDialog/SET_DIALOG_ACTIVE'
const SET_DIALOG_INACTIVE = 'fulcrum/container/Approval/ApprovalDialog/SET_DIALOG_INACTIVE'
const SUBMIT = 'fulcrum/container/Approval/ApprovalDialog/SUBMIT'
const SUBMIT_START = 'fulcrum/container/Approval/ApprovalDialog/SUBMIT_START'

const APPROVAL_TYPE = Object.freeze({
  APPROVE: 'approve',
  REJECT: 'reject'
})

const APPROVE_TYPE = Object.freeze({
  SKIP_TO_KICKOFF: {
    value: 'SKIP_TO_KICKOFF',
    label: 'containers.approval.approvalDialog.acceptDialog.skipToKickoff'
  },
  SKIP_TO_DESIGN_REVIEW: {
    value: 'SKIP_TO_DESIGN_REVIEW',
    label: 'containers.approval.approvalDialog.acceptDialog.skipToDesignReview'
  },
  SKIP_TO_QUALIFICATION: {
    value: 'SKIP_TO_QUALIFICATION',
    label: 'containers.approval.approvalDialog.acceptDialog.skipToQualification'
  },
  SUBMIT: {
    value: 'SUBMIT',
    label: 'containers.approval.approvalDialog.acceptDialog.approval'
  }
})

export {
  CLEAR,
  SUBMIT,
  SUBMIT_START,
  MODULE_NAME,
  APPROVAL_TYPE,
  APPROVE_TYPE,
  UPDATE_COMMENT,
  UPDATE_ACTIVE,
  UPDATE_TYPE,
  UPDATE_DIALOG_TYPE,
  SET_DIALOG_ACTIVE,
  SET_DIALOG_INACTIVE,
  UPDATE_WORKFLOW_ID,
  UPDATE_PROJECT_ID,
  UPDATE_SKIPABLES
}
